import {
  ChevronLeft,
  ChevronRight,
} from 'src/components/TimeSheet/styles/TimesheetsTableHeader.styled';
import {
  GoalsQuartersContainer,
  QuarterField,
  QuarterSelector,
  QuarterOption,
  QuarterArrowContainer,
  StyledLink,
} from './style/GoalsHeader.styled';
import { Period } from 'src/tabs/models/GoalsInterfaces';

interface GoalsHeaderProps {
  activePeriods: Period[];
  selectedPeriod: string;
  showInvalidPeriods: boolean;
  setSelectedPeriod: (period: string) => void;
  setShowInvalidPeriods: (value: boolean) => void;
  setIsReadOnlyPeriod: (value: boolean) => void;
}

export const GoalsHeader = ({
  activePeriods,
  selectedPeriod,
  showInvalidPeriods,
  setSelectedPeriod,
  setShowInvalidPeriods,
  setIsReadOnlyPeriod,
}: GoalsHeaderProps) => {
  const areAnyInactivePeriods = !!activePeriods.filter(
    (period) => period.statuscode !== 1
  )?.length;

  const handlePeriodChange = (period: Period) => {
    setSelectedPeriod(period.new_axsperiodid);
    setIsReadOnlyPeriod(period.statuscode !== 1);
  };

  const handlePreviousPeriod = () => {
    const periodIndex = activePeriods.findIndex(
      (period) => period.new_axsperiodid === selectedPeriod
    );
    if (!activePeriods[periodIndex + 1]) return;
    setSelectedPeriod(activePeriods[periodIndex + 1]?.new_axsperiodid);
    setIsReadOnlyPeriod(activePeriods[periodIndex + 1]?.statuscode !== 1);
  };

  const handleNextPeriod = () => {
    const periodIndex = activePeriods.findIndex(
      (period) => period.new_axsperiodid === selectedPeriod
    );
    if (!activePeriods[periodIndex - 1]) return;
    setSelectedPeriod(activePeriods[periodIndex - 1]?.new_axsperiodid);
    setIsReadOnlyPeriod(activePeriods[periodIndex - 1]?.statuscode !== 1);
  };

  return (
    <GoalsQuartersContainer>
      <QuarterField size="small">
        <QuarterSelector
          appearance="underline"
          readOnly
          value={
            activePeriods.find(
              (period) => period.new_axsperiodid === selectedPeriod
            )?.new_name
          }
          defaultValue={'activePeriods[0].new_name'}
          listbox={{
            style: { minWidth: '110px', width: '110px' },
          }}
        >
          {activePeriods.reduce((acc, period) => {
            if (showInvalidPeriods || period.statuscode === 1) {
              return [
                ...acc,
                <QuarterOption
                  key={period.new_axsperiodid}
                  checkIcon={{
                    style: { display: 'none' },
                  }}
                  onClick={() => handlePeriodChange(period)}
                  isSelected={selectedPeriod === period.new_axsperiodid}
                >
                  {period.new_name}
                </QuarterOption>,
              ];
            }
            return acc;
          }, [])}
          {areAnyInactivePeriods && (
            <StyledLink
              onClick={() => setShowInvalidPeriods(!showInvalidPeriods)}
            >
              {showInvalidPeriods ? 'See less' : 'See more'}
            </StyledLink>
          )}
        </QuarterSelector>
      </QuarterField>
      <QuarterArrowContainer>
        <ChevronLeft onClick={handlePreviousPeriod} />
        <ChevronRight onClick={handleNextPeriod} />
      </QuarterArrowContainer>
    </GoalsQuartersContainer>
  );
};
